import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.page.html',
  styleUrls: ['./imprint.page.scss'],
})
export class ImprintPage implements OnInit {

  slug: any;

  constructor(private route: ActivatedRoute, public appService: AppServiceService) {

    this.route.params.subscribe((param) => {
      this.slug = param.slug;
    });

  }

  ngOnInit() {
  }


  ionViewDidEnter() {

    this.appService.getRestaurantBySlug(this.slug);

  }

}
